// import { useState } from 'react';
import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { Divider, useTheme } from '@mui/material';
import { tokens } from '../../theme';

import { formatDateCreatedAt } from '../../utils/formats';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from 'react';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import ExportToExcelShowTable from '../../components/global/excel-file-show-table';

import { IconButton, Popover } from "@mui/material";
import { djangoApi } from '../../utils/axios/axios.utils';
import Swal from 'sweetalert2'
import toast from 'react-hot-toast';

import { deleteProdSellersKits } from '../../store/products/products.action';
import { useDispatch } from 'react-redux';



const formatNumber = (data) => {
    return data?.toLocaleString(
        "pt-br",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    )
}

const ProductTable = ({ products, setTotalVendas, setTotalVendasUnit, isKitActive, setFilterProdsAfter }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch()


    useEffect(() => {
        if (products) {
            const totalVendas = products?.filter((data) => data?.devolvido === false).reduce((acc, curr) => acc += curr.sell_price, 0)
            setTotalVendas(totalVendas)
            const totalVendasUnit = products?.filter((data) => data?.devolvido === false).reduce((acc, curr) => acc += 1, 0)
            setTotalVendasUnit(totalVendasUnit)
        }
    }, [products]);

    const [anchorEl, setAnchorEl] = useState(null);
    const [hoveredImage, setHoveredImage] = useState(null);
    const [popoverPosition, setPopoverPosition] = useState('bottom'); // default



    const handlePopoverClose = () => {
        setAnchorEl(null);
        setHoveredImage(null);
    };

    const open = Boolean(anchorEl);
    const handlePopoverOpen = (event, imageUrl) => {
        const rect = event.currentTarget.getBoundingClientRect();

        const isNearBottom = rect.bottom + 800 > window.innerHeight; // 200px = popover height
        setPopoverPosition(isNearBottom ? 'top' : 'bottom');

        setAnchorEl(event.currentTarget);
        setHoveredImage(imageUrl);
    };

    const handleDelete = async (product) => {
        try {
            const res = await djangoApi.post(
                `products/register_prods/${product.pk_kit_product}/delete_kit_product/`,
                {}, // corpo vazio
                {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            if (res.status === 204) {
                toast.success("Produto removido do kit com sucesso!", {
                    position: 'top-right'
                });
                dispatch(deleteProdSellersKits(isKitActive, product.pk_kit_product))
                setFilterProdsAfter((prev) => {
                    const indexToRemove = prev.findIndex(data => data.pk_kit_product === product.pk_kit_product);

                    if (indexToRemove === -1) return prev; // não encontrou, retorna o original

                    const newArray = [...prev];
                    newArray.splice(indexToRemove, 1); // remove só 1 item no índice encontrado

                    return newArray;
                });
                // Aqui você pode atualizar sua lista local ou fazer novo fetch
            }
        } catch (error) {
            console.error('Erro ao excluir produto:', error);
            Swal.fire({
                icon: 'error',
                title: 'Erro ao excluir',
                text: 'Ocorreu um erro ao tentar remover o produto do kit.',
                confirmButtonColor: '#d33',
                confirmButtonText: 'Fechar'
            });
        }
    };

    return (
        <>

            <TableContainer component={Paper} elevation={8}>
                <Table size='small' stickyHeader>
                    <TableHead>
                        <TableRow
                            sx={{
                                backgroundColor: `${colors.pink[200]} !important`
                            }}
                        >
                            <TableCell align="center"><Typography variant="h6"></Typography></TableCell>
                            <TableCell align="center"><Typography variant="h6">ID Produto</Typography></TableCell>
                            {/* <TableCell align="center"><Typography variant="h6">Quantity</Typography></TableCell> */}
                            <TableCell align="center"><Typography variant="h6">Preço Cobrado</Typography></TableCell>
                            <TableCell align="center"><Typography variant="h6">Tipo</Typography></TableCell>
                            <TableCell align="center"><Typography variant="h6">Tamanho</Typography></TableCell>
                            <TableCell align="center"><Typography variant="h6">Inserido</Typography></TableCell>
                            <TableCell align="center"><Typography variant="h6">Status</Typography></TableCell>
                            <TableCell align="center"><Typography variant="h6">Vendido</Typography></TableCell>
                            <TableCell align="center"><Typography variant="h6">Excluir</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {products?.map((product, index) => {
                            return (
                                <TableRow key={index}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? colors.grey[700] : colors.grey[600],
                                        '&:hover td': {
                                            borderTop: `2px solid ${colors.pink[400]}`,
                                            borderBottom: `2px solid ${colors.pink[400]}`,
                                        },
                                    }}
                                >
                                    <TableCell align="center">{index + 1}</TableCell>
                                    <TableCell align="center"
                                        onMouseEnter={(e) => handlePopoverOpen(e, product.imageUrl)}
                                        onMouseLeave={handlePopoverClose}
                                        sx={{
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {product.product_id}
                                    </TableCell>
                                    {/* <TableCell align="center">{product.quantity}</TableCell> */}
                                    <TableCell align="center">R$ {formatNumber(product.sell_price)}</TableCell>
                                    <TableCell align="center">{product.content_type}</TableCell>
                                    <TableCell align="center">{product?.tamanho ? product?.tamanho : '-'}</TableCell>
                                    <TableCell align="center">{formatDateCreatedAt(product.created_at)}</TableCell>
                                    <TableCell align="center">
                                        {!product?.devolvido ?
                                            'Vendido'
                                            :
                                            'Devolvido'
                                        }
                                    </TableCell>
                                    <TableCell align="center">
                                        {!product?.devolvido ?
                                            <FontAwesomeIcon icon={faCircleCheck} color={colors.greenAccent[600]} />
                                            :
                                            <FontAwesomeIcon icon={faCircleXmark} color={colors.redAccent[500]} />
                                        }
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton onClick={() => handleDelete(product)} color="error" disabled={!isKitActive?.is_active && isKitActive?.is_delivered_to}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: popoverPosition,
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: popoverPosition === 'bottom' ? 'top' : 'bottom',
                    horizontal: 'left',
                }}
                disableRestoreFocus
                sx={{ pointerEvents: 'none' }}
            >
                {hoveredImage && (
                    <img
                        src={hoveredImage}
                        alt="Preview"
                        style={{ width: 350, height: 'auto', padding: 8 }}
                    />
                )}
            </Popover>
        </>
    );
};



const ShowProductsPage = ({ open, setOpen, products, sellersData }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [totalVendas, setTotalVendas] = useState(0);
    const [totalVendasUnit, setTotalVendasUnit] = useState(0);


    const [filterProds, setFilterProds] = useState('all');
    const [filterProdsAfter, setFilterProdsAfter] = useState([]);

    const handleFilterProds = (event) => {
        setFilterProds(event.target.value)
    }

    useEffect(() => {
        if (products) {
            const expandedProducts = products?.kit_products?.flatMap(product => {
                const { quantity, quantity_returned } = product;

                return Array.from({ length: quantity }, (_, index) => ({
                    ...product,
                    quantity: index + 1, // Set the row number (1, 2, ...)
                    devolvido: index < quantity_returned // Mark as devolvido (returned) if within returned count
                }));
            }).sort((b, a) => String(b.product_id).localeCompare(String(a.product_id), 'pt', { numeric: true }))

            setFilterProdsAfter(expandedProducts)
        }
    }, [products]);

    useEffect(() => {
        if (products) {
            const expandedProducts = products?.kit_products?.flatMap(product => {
                const { quantity, quantity_returned } = product;

                return Array.from({ length: quantity }, (_, index) => ({
                    ...product,
                    quantity: index + 1, // Set the row number (1, 2, ...)
                    devolvido: index < quantity_returned // Mark as devolvido (returned) if within returned count
                }));
            }).sort((b, a) => String(b.product_id).localeCompare(String(a.product_id), 'pt', { numeric: true }))

            if (filterProds === 'all') {
                setFilterProdsAfter(expandedProducts)
            } else if (filterProds === 'sold') {
                setFilterProdsAfter(expandedProducts.filter((data) => data.devolvido === false))
            } else if (filterProds === 'regular') {
                setFilterProdsAfter(expandedProducts.filter((data) => data.devolvido === true))
            }
        }
    }, [filterProds]);


    const handleClose = () => {
        setOpen(false)
    }
    const style = {
        position: 'absolute',
        top: '50%',  // Center vertically
        left: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Adjust to center
        width: '80%',  // Fixed width
        height: '90%', // Fixed height
        // bgcolor: 'background.paper',
        bgcolor: colors.grey[300],
        color: 'black',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2, // Adjust padding as needed
        display: 'flex', // Flexbox for alignment
        flexDirection: 'column', // Stack items vertically
        justifyContent: 'flex-start', // Center items vertically
        alignItems: 'center' // Center items horizontally
    };

    const totalProds = products?.kit_products?.reduce((acc, curr) => acc += curr.quantity, 0)
    const totalProdsValue = products?.kit_products?.reduce((acc, curr) => acc += (curr.quantity * curr.sell_price), 0)
    console.log('products::::', products)

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Fade in={open}>

                    <Box sx={style}>
                        <Paper
                            elevation={8}
                            sx={{
                                width: '100%',
                                backgroundColor: colors.pink[700],
                                padding: '20px',
                                marginBottom: '20px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '100%',
                                    justifyContent: 'space-between',
                                    marginBottom: '20px'
                                }}
                            >
                                <Box>

                                    <Typography variant='h4' color="whitesmoke" fontWeight={"bold"}>
                                        KIT: {products.kit_number}
                                    </Typography>
                                    <FormControl>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="controlled-radio-buttons-group"
                                            value={filterProds}
                                            onChange={handleFilterProds}
                                        >
                                            <FormControlLabel value="all" control={<Radio color='secondary' />} label="Todos" />
                                            <FormControlLabel value="sold" control={<Radio color='secondary' />} label="Vendidos" />
                                            <FormControlLabel value="regular" control={<Radio color='secondary' />} label="Não Vendidos" />
                                        </RadioGroup>
                                    </FormControl>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'end',
                                        flexDirection: 'column',
                                        alignItems: 'flex-end',

                                    }}
                                >
                                    <ExportToExcelShowTable
                                        data={filterProdsAfter}
                                        kit_number={products.kit_number}
                                        sellersData={sellersData}
                                    />

                                    <Typography variant='h6' color="whitesmoke" fontWeight={"bold"}>
                                        {totalProds} Itens
                                    </Typography>
                                    <Typography variant='h6' color="whitesmoke" fontWeight={"bold"}>
                                        R$ {formatNumber(totalProdsValue)}
                                    </Typography>
                                </Box>
                            </Box>
                            {
                                !products.is_active &&
                                <>
                                    <Divider style={{ width: '100%' }} />
                                    <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-start', flexDirection: 'column', alignItems: 'start' }}>
                                        <Typography variant='h6' color="whitesmoke" fontWeight={"bold"}>Vendas: R$ {formatNumber(totalVendas)}</Typography>
                                        <Typography variant='h6' color="whitesmoke" fontWeight={"bold"}>Produtos Vendidos: {totalVendasUnit}</Typography>
                                    </Box>
                                </>
                            }
                        </Paper>
                        <ProductTable
                            products={filterProdsAfter}
                            setTotalVendasUnit={setTotalVendasUnit}
                            setTotalVendas={setTotalVendas}
                            isKitActive={products}
                            setFilterProdsAfter={setFilterProdsAfter}
                        />
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
export default ShowProductsPage;